import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/home/index';
import GithubProjects from './pages/github-projects/index';
import DarijaPage from './pages/darija/index';
import UpdatePage from './pages/update/index';
import { ThemeProvider } from './shared/context/ThemeContext';
import { LanguageProvider } from './shared/context/LanguageContext';
import './shared/styles/index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <ThemeProvider>
        <LanguageProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/darija" element={<DarijaPage />} />
                    <Route path="/github-projects" element={<GithubProjects />} />
                    <Route path="/Update" element={<UpdatePage />} />
                </Routes>
            </BrowserRouter>
        </LanguageProvider>
    </ThemeProvider>
);
